import React, { useState } from "react";
import { Button, Modal, Row, Col, Card, Form } from "react-bootstrap";
import Select from "react-select";
import { useHistory } from "react-router";
import { topCsls } from "../constants/topCsls";

export default function CslSelector({
  changedCsl,
  active_csl,
  imported_csls,
  set_imported_csls,
}) {
  const history = useHistory();

  const [show, setShow] = useState(false);
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([
    ...topCsls.map(item => ({
      value: item.key,
      label: item.value,
      id: item.id,
    })),
    { value: "SEARCH", label: "جستجو در شیوه‌نامه‌ها...", more: true },
  ]);

  const isFarsi = text => /[\u0600-\u06FF]/.test(text);

  const openModal = () => {
    setQuery("");
    setShow(true);
  };
  const closeModal = () => setShow(false);

  const onSearchChange = e => {
    const txt = e.target.value.replace("ي", "ی").replace("ك", "ک");
    setQuery(txt);
  };

  const selectFromModal = item => {
    set_imported_csls([...imported_csls, item]);

    if (!options.find(o => o.value === item.key)) {
      setOptions([
        ...options.slice(0, -1),
        { value: item.key, label: item.value, id: item.id },
        options[options.length - 1],
      ]);
    }

    changedCsl(item);
    closeModal();
  };

  const normalizedQuery = (query || "").trim().toLowerCase();

  const safeImportedCsls = Array.isArray(imported_csls) ? imported_csls : [];

  const filtered = safeImportedCsls.filter(item => {
    const label = (item && (item.value ?? item.label ?? item.name ?? "")) + "";
    return label.toLowerCase().includes(normalizedQuery);
  });

  const onSelectChange = opt => {
    if (!opt) return;
    if (opt.value === "SEARCH") {
      openModal();
    } else {
      const found = options.find(o => o.value === opt.value);
      changedCsl({
        key: found.value,
        value: found.label,
        id: found.id,
      });
    }
  };

  return (
    <>
      <Row style={{ marginBottom: 10 }}>
        <Col md={12} className="mt-2">
          <Select
            options={options}
            className="csl-select"
            value={
              active_csl
                ? {
                    value: active_csl.key,
                    label: active_csl.value,
                    id: active_csl.id,
                  }
                : null
            }
            onChange={onSelectChange}
            isSearchable={false}
            placeholder={active_csl ? active_csl.value : "انتخاب شیوه‌نامه…"}
            styles={{
              menuList: provided => ({
                ...provided,
                direction: "ltr",
              }),
              option: (prov, state) => {
                if (state.data.more) return { ...prov, background: "#EEE" };
                if (state.isSelected)
                  return { ...prov, background: "#48a4b3", color: "#FFF" };
                if (state.isFocused) return { ...prov, background: "#EEF" };
                return prov;
              },
            }}
            getOptionLabel={opt => (
              <div
                style={{
                  direction: isFarsi(opt.label) ? "rtl" : "ltr",
                  textAlign: isFarsi(opt.label) ? "right" : "left",
                }}>
                {opt.label}
              </div>
            )}
          />
        </Col>
      </Row>

      <Modal
        size="lg"
        show={show}
        onHide={closeModal}
        className="csl-modal search-csl-modal"
        style={{ zIndex: 9999 }}>
        <Modal.Header>
          <Modal.Title>جستجو در شیوه‌نامه‌ها</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Control
              type="text"
              placeholder="عنوان شیوه‌نامه"
              value={query}
              onChange={onSearchChange}
              className="text-right"
            />
          </Form.Group>

          <div
            className="csl-list-content"
            style={{ maxHeight: 400, overflowY: "auto" }}>
            <Row className="mx-0">
              {filtered.length === 0 && (
                <Col md={12} style={{ textAlign: "center", padding: 20 }}>
                  شیوه‌نامه‌ای یافت نشد.
                  <div style={{ marginTop: 10 }}>
                    <Button variant="info" onClick={() => history.push("/csl")}>
                      سفارش شیوه‌نامه
                    </Button>
                  </div>
                </Col>
              )}

              {filtered.map((item, idx) => {
                const displayLabel = item?.value ?? item?.label ?? "";
                const rtl = isFarsi(displayLabel || "");
                const isActive = active_csl?.key === item.key;

                return (
                  <Col md={12} key={idx} style={{ marginBottom: 8 }}>
                    <Card
                      className={`csl-row ${isActive ? "selected" : ""}`}
                      onClick={() => selectFromModal(item)}>
                      <Card.Body
                        style={{
                          direction: rtl ? "rtl" : "ltr",
                          textAlign: rtl ? "right" : "left",
                        }}>
                        {displayLabel}
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={closeModal}>
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
